/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unused-vars */
import React from 'react'
import MainLayout from '../../Layouts/Mainlayout'
import { useParams } from 'react-router-dom'
import { useLocation } from "react-router";
import EditESPTabs from './EditESPTabs';

const EditESP: React.FC = () => {

  const param = useParams();
  const data: any = useLocation();
  const {id} = param;
  return (
    <div className="flex flex-row justify-start">
      <MainLayout>
        <EditESPTabs espId={id} espData={data.state.espData} />
      </MainLayout>
    </div>
  )
}

export default EditESP